import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { ref, get, child, update } from "firebase/database";
import { database as db } from "./../firebaseConfig";

// Admin tool: clears the saved unit and building for every user so
// everyone re-confirms where they're staying before the new season.
export default function PurgeInfoDialog({ open, onClose }) {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const handlePurge = async () => {
    setBusy(true);
    setResult(null);
    try {
      const snapshot = await get(child(ref(db), "users"));
      const users = snapshot.exists() ? snapshot.val() : {};
      const updates = {};
      let cleared = 0;
      for (const uid of Object.keys(users)) {
        if (users[uid]?.unit != null || users[uid]?.building != null) cleared++;
        updates[`users/${uid}/unit`] = null;
        updates[`users/${uid}/building`] = null;
      }
      if (Object.keys(updates).length) await update(ref(db), updates);
      setResult({
        severity: "success",
        message: `Cleared unit & building for ${cleared} user${
          cleared === 1 ? "" : "s"
        }. Everyone (including you) will be asked to update their info on their next visit.`,
      });
    } catch (error) {
      setResult({
        severity: "error",
        message: `Purge failed: ${error.message || error}`,
      });
    } finally {
      setBusy(false);
    }
  };

  const handleClose = () => {
    if (busy) return;
    setResult(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Purge Unit & Building Info</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This clears the saved unit and building for every user, so each
          guest confirms their current stay before reserving sets this
          season. It cannot be undone.
        </DialogContentText>
        {result && (
          <Alert severity={result.severity} sx={{ mt: 2 }}>
            {result.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={busy}>
          Close
        </Button>
        <Button
          onClick={handlePurge}
          color="error"
          variant="contained"
          disabled={busy || result?.severity === "success"}
          startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {busy ? "Purging…" : "Purge All Users"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
